export default {
  title: 'Chiudi disponibilità',
  close_availabilities_form: {
    date_range: {
      label: "Seleziona una data e un'ora.",
    },
  },
  reason: {
    label: 'Aggiungi un motivo (opzionale)',
    placeholder: 'Inserisci descrizione...',
  },
  recurring: {
    label: 'Ricorrente annualmente',
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
    add: '+ Aggiungi eccezione',
    reactivate: 'Riattiva',
  },
  reservations: {
    title: 'Prenotazioni',
    description: "Vuoi aggiungere l'eccezione al programma alle prenotazioni?",
    add: 'Aggiungi',
    cancel: 'Annulla',
  },
  projects: {
    online_shop: 'Negozio online',
    reservations: 'Prenotazioni',
    storefront: 'Vetrina',
  },
  success_messages: {
    reservation_updated: 'Eccezione al programma aggiunta con successo',
  },
  error_messages: {
    date_range_required: 'Seleziona un intervallo di date.',
    creation_failed: 'Creazione eccezione fallita',
    overlapping_schedule_exception: "Esiste già un'eccezione al programma per quell'intervallo di tempo",
    merge_schedule_exceptions:
      "La seguente eccezione {{oldDate}} verrà unita con {{newDate}}. Puoi anche aggiornare l'intervallo di date per {{oldDate}}.",
  },
};
